import styled from 'styled-components';

import type { Rarity } from '#src/__generated__/globalTypes.ts';
import { AnimatedNumber } from '#src/atoms/animations/AnimatedNumber/index.tsx';
import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { Shards } from '#src/atoms/icons/Shards.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelM } from '#src/atoms/typography/index.tsx';
import { isSupportedCardSet } from '#src/lib/cardSets.tsx';
import { getRarityShardColor } from '#src/lib/colors.ts';

const IconWrapper = styled(Horizontal).attrs({ center: true })`
  width: var(--triple-unit);
  height: var(--triple-unit);
  border-radius: 50%;
  background: var(--c-nl-800);

  & > img {
    height: 16px;
    object-fit: contain;
  }
`;

const Root = styled(ButtonBase)`
  border-radius: var(--double-unit);
  padding-left: var(--unit);
  background: var(--c-nl-500);
  display: flex;
  &:hover {
    background: var(--c-nl-600);
  }
`;

type Props = {
  value: number;
  rarity: Rarity;
  cardSetSlug?: string;
};
export const EssenceBalance = ({ value, rarity, cardSetSlug }: Props) => {
  const shardColor = getRarityShardColor(
    rarity,
    isSupportedCardSet(cardSetSlug) ? cardSetSlug : null
  );
  return (
    <Root>
      <Horizontal gap={0.5}>
        <LabelM bold>
          <AnimatedNumber value={value} disableAnimationOnFirstRender />
        </LabelM>
        <IconWrapper>
          <Shards color={shardColor} size={2} />
        </IconWrapper>
      </Horizontal>
    </Root>
  );
};
